import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Pagination from '../../../components/tables/pagination/Pagination';
import CustomLoading from '../../../components/customLoading/CustomLoading';
import Table from '../../../components/tables/Table';
import loaderImage from "../../../assets/icons/part-logo.png";
import StyledHeadingText from '../../../components/Fonts/StyledHeadingText';
import { toast } from 'react-toastify';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BiHistory, BiPencil } from 'react-icons/bi';
import { GoPackage } from 'react-icons/go';
import { LuFileScan } from 'react-icons/lu';
import { getNewHudPatients, getNewHudPatientsFilteredToday, updateNewHudPatientDoctorView } from '../../../services/new_clinic/new_hud_patients';
import { getUserName } from '../../../utils/localStoarege';


function PackageFilteredTable() {
    const [tableData, setTableData] = useState({});
    const headers = [
        { label: "Date", key: "date" },
        { label: "Patient Name", key: "patient_name" },
        { label: "Type", key: "package_type" },
        { label: "Dose Count", key: "dose_count" },
        { label: "Center", key: "center_name" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const [rowData, setRowData] = useState({});


    const pageSize = 10;

    const fetchData = async (query, center) => {
        setLoading(true);
        try {
            let res = await getNewHudPatientsFilteredToday(getUserName() || center || "", query);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Patients");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Patients:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
            let date = "";
            let isYesterday = "";
            try {
                date = location.search.split("=")[1].split("&")[0];
                isYesterday = location.search.split("=")[2];
            } catch (error) {
                console.log(error);
            }
            fetchData(`&package_type=${location.state.package_type}&date=${date}&yesterday=${isYesterday}`, location.state.center);
        } else {
            navigate(-1);
            toast.error("Not able to open machine directly!");
        }
    }, [location]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <div className="flex flex-row justify-between items-center mb-2">
            <div className="flex flex-row gap-1">
                <Breadcrumbs items={[
                    { name: 'Filtered Patients' },
                ]} />
                <StyledHeadingText text={`| ${rowData.title}`} size={"text-xs"} />
            </div>
        </div>
        <div className="bg-white p-4 w-full rounded border-primary border-t-2">
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading imageSrc={loaderImage} size={100} />
                    </div>
                    :
                    <div className="mt-2">
                        <Table
                            headers={headers}
                            rows={tableData?.results?.map((item, index) => (
                                {
                                    patient_name: <b className='text-black py-1'>{item.patient_name}</b>,
                                    dose_count: <p className='py-1'>{item.dose_count}</p>,
                                    package_type: <p className='py-1'>{item.package_type}</p>,
                                    date: <p className='py-1'>{item.date}</p>,
                                    center_name: <p className='py-1'>{item.center_name}</p>,
                                }))}
                        />
                    </div>}
            {
                tableData.count !== 0 ?
                    <div className="xl:pl-5 pl-0">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(tableData?.count / pageSize)}
                            pageSize={pageSize}
                            totalEntries={tableData?.count}
                            onPageChange={handlePageChange}
                            data={tableData}
                            setTableData={setTableData}
                        />
                    </div> : <></>
            }
        </div>
    </>);
}

export default PackageFilteredTable;